import { axiosWithAuth } from "../../helpers";

export const dropdownValuesService = {
	getProcessors,
	getSponsors,
	getScheduleAList,
	getSplitProfiles,
	getPdfTemplates,
	getMccAliases,
	getBanks,
	getMerchantStatuses,
	getCompanies,
	getAgentOffices,
	getAgentOfficesResiduals,
	getAllowedCompanies,
	getCompanyUsers,
	getPrimaryAgents,
	getDomains,
	getPreAppPrimaryAgents,
	getUsers,
	getAgentAssignees,
	getTerminals,
	getGateways,
	getTimeZone,
	getPendReasons,
	getKeySupportResponsibilities,
	getUserRoles,
	getCompanyStatuses,
	getPciClientIds,
	getPayoutMethods,
	getAccountTypes,
	getMedianItems,
	getSplitProfileAgents,

	getFdOmahaProcessorTypes,

	getEquipmentQueueUsers,
	getAdjustmentCategories,
	getAdjustmentAgents,

	getAgentAssignee,

	getUsersWithPartnerTypeOrRole,

	getIsvsTypes,
	getCountries,
	getAssociationPartners,
	getMerchantsByMid,
};

const PAGE_SIZE = 50;
const API_URL = process.env.REACT_APP_API_URL;
const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;

function getProcessors(applicationId, pageName) {
	const params = { application_id: applicationId };

	if (pageName) {
		params.deal_stage = pageName;
	}

	const options = {
		method: "GET",
		params: params,
		url: `${API_URL}/api/dropdown/application/processors`,
	};

	return axiosWithAuth(options);
}

function getSponsors(applicationId, pageName) {
	const params = { application_id: applicationId };

	if (pageName) {
		params.page_name = pageName;
	}

	const options = {
		method: "GET",
		params: params,
		url: `${API_URL}/api/dropdown/application/sponsors`,
	};

	return axiosWithAuth(options);
}

function getScheduleAList(
	agentId,
	{ showInactive = false, sortBy = "name", ascending = true } = {},
) {
	const options = {
		method: "GET",
		params: {
			show_inactive: showInactive,
			sort_by: sortBy,
			ascending,
		},
		url: `${API_URL}/api/dropdown/agents/${agentId}/schedule_a_list`,
	};

	return axiosWithAuth(options);
}

function getSplitProfiles(
	agentId,
	{
		showInactive = false,
		showHighRisk = false,
		sortBy = "name",
		ascending = true,
	} = {},
) {
	const options = {
		method: "GET",
		params: {
			show_inactive: showInactive,
			show_high_risk: showHighRisk,
			sort_by: sortBy,
			ascending,
		},
		url: `${API_URL}/api/dropdown/agents/${agentId}/split_profiles`,
	};

	return axiosWithAuth(options);
}

function getPdfTemplates() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/application/pdf_templates`,
	};

	return axiosWithAuth(options);
}

function getAdjustmentCategories() {
	const options = {
		method: "GET",
		url: `${RESIDUALS_API_URL}/api/resources/source_file/adjustment_categories`,
	};

	return axiosWithAuth(options);
}

function getAdjustmentAgents({ paidYear, paidMonth, search, page }) {
	const options = {
		method: "GET",
		params: {
			search_for: search,
			page_index: page,
			page_size: 20,
		},
		url: `${RESIDUALS_API_URL}/api/adjustments/${paidYear}/${paidMonth}/agents`,
	};

	return axiosWithAuth(options);
}

function getUsers(page, pattern, merchant_id) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			search_for: pattern ? pattern : undefined,
			page_size: PAGE_SIZE,
			merchant_id,
		},
		url: `${API_URL}/api/tickets/allowed_users`,
	};

	return axiosWithAuth(options);
}

function getMccAliases({ pattern, page }) {
	const options = {
		method: "GET",
		params: {
			pattern,
			page,
			page_size: 2000,
		},
		url: `${API_URL}/api/dropdown/mcc_aliases`,
	};

	return axiosWithAuth(options);
}

function getBanks(body) {
	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/dropdown/Banks`,
	};

	return axiosWithAuth(options);
}

function getMerchantStatuses() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/merchants/merchantStatuses`,
	};

	return axiosWithAuth(options);
}

function getMerchantsByMid(pageIndex, pageSize, mid) {
	const options = {
		method: "GET",
		params: {
			page_index: pageIndex,
			page_size: pageSize,
			mid: mid,
		},
		url: `${API_URL}/api/merchants`,
	};

	return axiosWithAuth(options);
}

function getCompanies(filter) {
	const options = {
		method: "GET",
		params: filter,
		url: `${API_URL}/api/dropdown/merchants/companies`,
	};

	return axiosWithAuth(options);
}

function getAgentOffices(pattern, page_index, page_size) {
	const options = {
		method: "GET",
		params: {
			pattern,
			page_index,
			page_size,
		},
		url: `${API_URL}/api/dropdown/agent_offices`,
	};

	return axiosWithAuth(options);
}

function getAgentOfficesResiduals(pattern, page_index, page_size) {
	const options = {
		method: "GET",
		params: {
			pattern,
			page_index,
			page_size,
		},
		url: `${RESIDUALS_API_URL}/api/resources/agent_offices`,
	};

	return axiosWithAuth(options);
}

function getAllowedCompanies({ status, excludeId }) {
	const options = {
		method: "GET",
		params: {
			page_index: 0,
			page_size: 3000,
			status,
			sort_type: "officeName",
			ascending: true,
			exclude_company_id: excludeId,
		},
		url: `${API_URL}/api/companies`,
	};

	return axiosWithAuth(options);
}

function getCompanyUsers({
	company_id,
	show_inactive,
	pattern,
	page_index,
	page_size,
} = {}) {
	const options = {
		method: "GET",
		params: {
			company_id,
			show_inactive,
			pattern,
			page_index,
			page_size,
		},
		url: `${API_URL}/api/dropdown/merchants/companyUsers`,
	};

	return axiosWithAuth(options);
}

function getPrimaryAgents(applicationId) {
	const options = {
		method: "GET",
		params: { applicationId },
		url: `${API_URL}/api/applications/primary-agents`,
	};

	return axiosWithAuth(options);
}

function getDomains() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/domains`,
	};

	return axiosWithAuth(options);
}

function getKeySupportResponsibilities() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/companies/key_support_responsibilities`,
	};

	return axiosWithAuth(options);
}

function getUserRoles() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/default_roles`,
	};

	return axiosWithAuth(options);
}

function getCompanyStatuses() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/company/statuses`,
	};

	return axiosWithAuth(options);
}

function getPreAppPrimaryAgents(model) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/pre-app/primary-agents`,
		data: {
			pageSize: 20,
			...model,
		},
	};

	return axiosWithAuth(options);
}

function getTerminals() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/application/terminals`,
	};

	return axiosWithAuth(options);
}

function getGateways() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/application/gateways`,
	};

	return axiosWithAuth(options);
}

function getTimeZone(timeZone) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/resources/timezones/${encodeURIComponent(
			timeZone,
		)}`,
	};

	return axiosWithAuth(options);
}

function getPendReasons() {
	const options = {
		url: `${API_URL}/api/dropdown/pend/reasons`,
	};
	return axiosWithAuth(options);
}

function getPciClientIds() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/pci_client_ids`,
	};

	return axiosWithAuth(options);
}

function getPayoutMethods() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/payout_methods`,
	};

	return axiosWithAuth(options);
}

function getAccountTypes() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/account_types`,
	};

	return axiosWithAuth(options);
}

function getMedianItems() {
	return Promise.resolve([
		{ name: "AM", value: "AM" },
		{ name: "PM", value: "PM" },
	]);
}

function getSplitProfileAgents(agentId, pattern, page, showInactive) {
	const options = {
		method: "GET",
		params: {
			search_for: pattern,
			page_index: page,
			page_size: 20,
			show_inactive: showInactive,
		},
		url: `${API_URL}/api/dropdown/agents/${agentId}/split_profile_agents`,
	};

	return axiosWithAuth(options);
}

function getFdOmahaProcessorTypes() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/fd_omaha_processor_types`,
	};

	return axiosWithAuth(options);
}

function getEquipmentQueueUsers({ pattern, page }) {
	const body = {
		pattern,
		page,
		pageSize: 20,
	};

	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/applications/equipment_queue/users`,
	};

	return axiosWithAuth(options);
}

function getAgentAssignee() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/agent_assignee`,
	};
	return axiosWithAuth(options);
}

function getAgentAssignees(page, pattern) {
	const options = {
		method: "GET",
		params: {
			show_inactive: true,
			search_for: pattern,
			page_index: page,
			page_size: PAGE_SIZE,
		},
		url: `${API_URL}/api/tickets/agent_assignees`,
	};

	return axiosWithAuth(options);
}

function getUsersWithPartnerTypeOrRole(
	pattern,
	page,
	allowedPartnerTypes,
	allowedRoles,
	showInactive = false,
) {
	const body = {
		pattern,
		page,
		pageSize: 20,
		showInactive,
		allowedPartnerTypes,
		allowedRoles,
	};

	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/dropdown/Users`,
	};

	return axiosWithAuth(options);
}

function getIsvsTypes() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/isvs`,
	};

	return axiosWithAuth(options);
}

function getCountries() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/countries`,
	};

	return axiosWithAuth(options);
}

function getAssociationPartners() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/association_partners`,
	};

	return axiosWithAuth(options);
}
